import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Location} from '@angular/common';
import { AppService } from 'src/app/app.service';
export interface checkerData {
  employeeId: string;
  firstName: string;
  lastName: string;
  designation: string;
  grade: string;
  dateOfJoining: string;
  plant: string;
  department: string;
  requester: string;
}
@Component({
  selector: 'app-itreviewform',
  templateUrl: './itreviewform.component.html',
  styleUrls: ['./itreviewform.component.scss']
})
export class ITReviewformComponent implements OnInit {

  checkerForm!: FormGroup;
    checkerData: any = {};
     
    constructor(private fb: FormBuilder,public appservice:AppService,private location:Location,private router: Router,private toastr: ToastrService) { }
    onApprove() {
      this.appservice.ticketcreationdata.command= this.checkerData.command;
      this.appservice.ticketcreationdata.createdby=this.appservice.username;
     this.appservice.getTable("api/Transaction/UpdateTicketStatus?id="+this.appservice.ticketcreationid+"&status="+"OnProcess").subscribe((res:any)=>{
        if(res=="True"){
  this.toastr.success("Approved successfully!");
  this.appservice.getcheckerdata();
  this.appservice.goback();
        }
      });
       
     // this.router.navigate(['/finalapprover']);
      
    }
    
    public employees:[
      { employeeId: 'E001', firstName: 'John', lastName: 'Doe', designation: 'Software Engineer', grade: 'A1', dateOfJoining: '2022-01-15', plant: 'Plant 1', department: 'IT', requester: 'Alice' },
      { employeeId: 'E002', firstName: 'Jane', lastName: 'Smith', designation: 'Project Manager', grade: 'B2', dateOfJoining: '2021-03-22', plant: 'Plant 2', department: 'Operations', requester: 'Bob' },
      { employeeId: 'E003', firstName: 'Michael', lastName: 'Johnson', designation: 'HR Executive', grade: 'C3', dateOfJoining: '2020-07-30', plant: 'Plant 1', department: 'HR', requester: 'Charlie' }
    ]
  
    onDecline() {
       this.appservice.ticketcreationdata.command= this.checkerData.command;
        this.appservice.ticketcreationdata.createdby=this.appservice.username;
     this.appservice.getTable("api/Transaction/UpdateTicketStatus?id="+this.appservice.ticketcreationid+"&status="+"Decline").subscribe((res:any)=>{
        if(res=="True"){
  this.toastr.success("Rejected successfully!");
  this.appservice.getcheckerdata();
  this.appservice.goback();
        }
      });
    }
    
    back(){
      this.location.back();
    }
  employeeid:any=[];
  getemployeeid(){
    this.appservice.getTable("Api/Transaction/GetEmployeeid").subscribe((res:any)=>{
      this.employeeid=JSON.parse(res);
      console.log("the values",this.checkerData.employeeid);
    })
  }
  Pending(){
    this.appservice.ticketcreationdata.command= this.checkerData.command;
        this.appservice.ticketcreationdata.createdby=this.appservice.username;
      this.appservice.getTable("api/Transaction/UpdateTicketStatus?id="+this.appservice.ticketcreationid+"&status="+"Close").subscribe((res:any)=>{
        if(res=="True"){
  this.toastr.success("Ticket Updated as Pending");
  this.appservice.getcheckerdata();
  this.appservice.goback();
        }
      });
  }
  public employeedetails:any={}
  Onselectempolyee(){
    this.appservice.getTable("Api/Transaction/Getticketdetails?empid="+this.appservice.ticketcreationid).subscribe((res:any)=>{
  this.employeedetails=res;
  this.checkerData=res;
  console.log("the Response is", this.employeedetails)
   //console.log("the values",this.employeedetails[0].OD_EmployeeID);
  // this.checkerData.employ
   if (this.employeedetails && this.employeedetails.length > 0) {
  
      this.checkerData = this.employeedetails[0]; 
      console.log("the emp data",this.checkerData);
        }
    });
  }
  fullImage: string | null = null;
openPreview(img: string) {
  this.fullImage = img;
}
  closePreview() {
  this.fullImage = null;
}
  formatToDDMMYYYY(dateStr: string): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${day}-${month}-${year}`;
  }
  formatDDMMYYYYToYYYYMMDD(dateStr: string): string {
    if (!dateStr) return '';
  
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  }
    ngOnInit(): void {
    //  this.getemployeeid();
    this.Onselectempolyee();
    }
  
    }
  
  
  
  
